import {
  DatePicker,
  Form,
  Input,
  Popconfirm,
  Select,
  Space,
  message,
} from "antd";
import { updateSettlementStatus } from "api/SettlementApi";
import ETag from "components/ETag";
import { SearchTable } from "components/Endeavour";
import { ISO8601 } from "components/Jarvis";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { Link, useSearchParams } from "react-router-dom";
import InlineCopyable from "components/InlineCopyable";
import { ColoredStatistic } from "components/Jarvis";

const { RangePicker } = DatePicker;
const rangePresets = [
  {
    label: "Today",
    value: [dayjs(), dayjs()],
  },
  {
    label: "Yesterday",
    value: [dayjs().add(-1, "d"), dayjs().add(-1, "d")],
  },
  {
    label: "Last 7 Days",
    value: [dayjs().add(-7, "d"), dayjs()],
  },
  {
    label: "Last 14 Days",
    value: [dayjs().add(-14, "d"), dayjs()],
  },
  {
    label: "Last 30 Days",
    value: [dayjs().add(-30, "d"), dayjs()],
  },
  {
    label: "Last 90 Days",
    value: [dayjs().add(-90, "d"), dayjs()],
  },
];

export default function SettlementPages() {
  const [form] = Form.useForm();
  const [searchParams, setSearchParams] = useSearchParams();
  const dateRange = searchParams.get("range")?.split(",");
  const [forceUpdate, setforceUpdate] = useState(0);
  const [query, setQuery] = useState("");
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const merchantID = localStorage.getItem("XMerchant");
  const merchant_name = localStorage.getItem("Merchant_name");
  const handleValues = {
    reference: searchParams.get("reference"),
    status: searchParams.get("status"),
    currency: searchParams.get("currency"),
    range: [
      dateRange?.[0] ? dayjs(dateRange[0], "YYYY-MM-DD") : null,
      dateRange?.[1] ? dayjs(dateRange[1], "YYYY-MM-DD") : null,
    ],
    timezone: timezone,
  };
  const { mutate: updateSettlement } = useMutation(
    (id) => updateSettlementStatus(id),
    {
      onSuccess: (res) => {
        if (res.code == 200) {
          message.info("Settlement Update");
          setforceUpdate((c) => c + 1);
        }
      },
    }
  );

  const handleFilters = (values) => {
    let data = {};
    const params = new URLSearchParams();
    let check = 0;
    for (let [k, v] of Object.entries(values)) {
      console.log(k);
      console.log(v);
      if (v === undefined || v === null || v === "") {
        check++;
        if (check === 4) {
          window.history.pushState(null, "", window.location.pathname);
          setQuery();
          break;
        }
        continue;
      }
      switch (k) {
        case "range":
          if (v?.[0] === null || v?.[1] === null) {
            continue;
          }
          const formated = v.map((date) => date.format("YYYY-MM-DD"));
          params.set("range", `${formated[0]},${formated[1]}`);
          data["range"] = [formated[0], formated[1]];
          break;
        default:
          params.set(k, v);
          data[k] = v;
      }
      params.set("timezone", timezone);
      data["timezone"] = timezone;
      let string = params.toString();
      window.history.pushState(
        null,
        "",
        window.location.pathname + (string ? "?" : "") + string
      );
      setQuery("?" + string);
    }

    setforceUpdate((forceUpdate) => forceUpdate + 1);
  };

  // useEffect(() => {
  //   handleFilters(form.getFieldsValue());
  // }, []);

  const handleDelete = (id) => {
    updateSettlement({ id: id, status: "Deleted" });
    setforceUpdate((c) => c + 1);
  };
  const handleApproved = (id) => {
    updateSettlement({ id: id, status: "Approved" });
    setforceUpdate((c) => c + 1);
  };

  const columns = [
    // {
    //     title: 'MID',
    //     key: 'MID',
    //     render: (item) => {
    //         return (
    //             <Link to={{
    //                 pathname: `/settlements/${item.id}`,
    //             }}> {item.merchant_id}</Link>
    //         );
    //     },

    // },
    {
      title: "Company Name",
      key: "display_name",
      render: (item) => {
        return (
          <Link
            to={{
              pathname: `/settlements/${item.id}`,
            }}
          >
            {" "}
            {item.display_name}
          </Link>
        );
      },
    },
    {
      title: "Settlement Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (item) => {
        let date = ISO8601(item);
        let output = date.split(", ");
        return output[0];
      },
    },
    {
      title: "Status",
      align: "center",
      key: "status",
      dataIndex: "status",
      render: (item) => {
        return <ETag>{item}</ETag>;
      },
    },

    {
      title: "Currency",
      align: "right",
      dataIndex: "currency",
      key: "currency",
    },
    {
      title: "Net Amount",
      align: "right",
      dataIndex: "net_amount",
      key: "net_amount",
    },
    {
      title: "Fee Amount",
      align: "right",
      dataIndex: "fee_amount",
      key: "fee_amount",
    },
    {
      title: "Settle Amount",
      align: "right",
      dataIndex: "settle_amount",
      key: "settle_amount",
    },
    {
      title: "Action",
      key: "action",
      render: (item) => {
        if (item.Status !== "Approved" && item.Status !== "Deleted") {
          return (
            <Space size="middle">
              <Popconfirm
                title="Approve Settlement"
                description="Are you sure to Approve this Settlement?"
                onConfirm={(e) => handleApproved(item.id)}
                okText="Yes"
                cancelText="No"
              >
                <a>Approve</a>
              </Popconfirm>
              <Popconfirm
                title="Delete Settlement"
                description="Are you sure to Delete this Settlement?"
                onConfirm={(e) => handleDelete(item.id)}
                okText="Yes"
                cancelText="No"
              >
                <a>Delete</a>
              </Popconfirm>
            </Space>
          );
        }
      },
    },
  ];

  return (
    <SearchTable
      name={["merchants", merchantID, "payments"]}
      title="Settlement"
      allowExport
      exportTotal={[
        "Amount",
        "Merchant Fee",
        "Surcharge",
        "Subtotal",
        "Settlement",
      ]}
      filename={`${merchant_name}_PaymentReport`}
      uri={`/payplus/transaction/${merchantID}`}
      uriParam={{ timezone: "Asia/Shanghai" }}
      searchFields={[
        <Form.Item label="Date Range" name="range">
          <RangePicker allowClear />
        </Form.Item>,
        <Form.Item label="Status" name="status">
          <Select allowClear>
            <Select.Option value="Created">Created</Select.Option>
            <Select.Option value="Pending">Pending</Select.Option>
            <Select.Option value="Processing">Processing</Select.Option>
            <Select.Option value="Completed">Completed</Select.Option>
            <Select.Option value="Expired">Expired</Select.Option>
          </Select>
        </Form.Item>,
      ]}
      exportColumns={[
        {
          title: "Payment Method",
          render: (item) => {
            let paymentMethod = item["Payment Method"];
            if (typeof paymentMethod === "string") {
              try {
                let tempValue = JSON.parse(paymentMethod);
                if (Array.isArray(tempValue)) {
                  paymentMethod = tempValue.join(", ");
                }
              } catch (JsonException) {}
            }
            return paymentMethod;
          },
        },
        {
          title: "Settlement Type",
          render: (item) => {
            return item["Settlement Type"];
          },
        },
        {
          title: "Reference",
          align: "center",
          render: (item) => {
            return item.Reference;
          },
        },
        {
          title: "Out Trade Number",
          align: "center",
          render: (item) => {
            return item["Out Trade Number"];
          },
        },
        {
          title: "Transaction Id",
          align: "center",
          outerWidth: 100,
          render: (item) => {
            return item["Transaction Id"];
          },
        },
        {
          title: "Type",
          align: "center",
          render: (item) => {
            return item.Type;
          },
        },
        {
          title: "Payment Time",
          align: "center",
          render: (item) => {
            return item["Payment Time"];
          },
        },
        {
          title: "Status",
          align: "center",
          render: (item) => {
            return item.Status;
          },
        },
        {
          title: "Currency",
          align: "center",
          render: (item) => {
            return item.Currency;
          },
        },
        {
          title: "Amount",
          align: "right",
          render: (item) => {
            return item.Amount;
          },
        },
        {
          title: "Merchant Fee",
          align: "right",
          render: (item) => {
            return item["Merchant Fee"];
          },
        },
        {
          title: "Surcharge",
          align: "right",
          render: (item) => {
            return item.Surcharge;
          },
        },
        {
          title: "Subtotal",
          align: "right",
          render: (item) => {
            return item.Subtotal;
          },
        },
        {
          title: "Settlement",
          align: "right",
          render: (item) => {
            return item.Settlement;
          },
        },
      ]}
      tableColumns={[
        {
          title: "Payment Method",
          render: (item) => {
            let paymentMethod = item["Payment Method"];
            if (typeof paymentMethod === "string") {
              try {
                let tempValue = JSON.parse(paymentMethod);
                if (Array.isArray(tempValue)) {
                  paymentMethod = tempValue.join(", ");
                }
              } catch (JsonException) {}
            }
            return paymentMethod;
          },
        },
        {
          title: "Settlement Type",
          render: (item) => {
            return item["Settlement Type"];
          },
        },
        {
          title: "Reference",
          align: "center",
          render: (item) => {
            return <InlineCopyable>{item.Reference}</InlineCopyable>;
          },
        },
        {
          title: "Out Trade Number",
          align: "center",
          render: (item) => {
            return item["Out Trade Number"].replace(/^`|`$/g, "");
          },
        },
        {
          title: "Transaction Id",
          align: "center",
          render: (item) => {
            return item["Transaction Id"].replace(/^`|`$/g, "");
          },
        },
        {
          title: "Type",
          align: "center",
          render: (item) => {
            return item.Type;
          },
        },
        {
          title: "Payment Time",
          align: "center",
          render: (item) => {
            return item["Payment Time"];
          },
        },
        {
          title: "Status",
          align: "center",
          render: (item) => {
            return <ETag>{item.Status}</ETag>;
          },
        },
        {
          title: "Order",
          align: "center",
          children: [
            {
              title: "Amount",
              align: "right",
              render: (item) => {
                return (
                  <ColoredStatistic
                    prefix={item.Currency}
                    value={item.Amount}
                  />
                );
              },
            },
            {
              title: "Merchant Fee",
              align: "right",
              render: (item) => {
                return (
                  <ColoredStatistic
                    prefix={item.Currency}
                    value={item["Merchant Fee"]}
                  />
                );
              },
            },
            {
              title: "Surcharge",
              align: "right",
              render: (item) => {
                return (
                  <ColoredStatistic
                    prefix={item.Currency}
                    value={item.Surcharge}
                  />
                );
              },
            },
            {
              title: "Subtotal",
              align: "right",
              render: (item) => {
                return (
                  <ColoredStatistic
                    prefix={item.Currency}
                    value={item.Subtotal}
                  />
                );
              },
            },
            {
              title: "Settlement",
              align: "right",
              render: (item) => {
                return (
                  <ColoredStatistic
                    prefix={item.Currency}
                    value={item.Settlement}
                  />
                );
              },
            },
          ],
        },
      ]}
    />
  );
}
